import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { InfoGraphic } from '@/models/info-graphic.model';

class InfoGraphicsService extends BaseService {
  private url: string = '/api/info-graphic';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<InfoGraphic>> {
    const res = await this.$http.get<InfoGraphic>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<InfoGraphic[]>> {
    const res = await this.$http.get<InfoGraphic[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    item: Partial<InfoGraphic>,
  ): Promise<DataResponse<InfoGraphic>> {
    const res = await this.$http.post<InfoGraphic>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: InfoGraphic): Promise<DataResponse<InfoGraphic>> {
    const res = await this.$http.put<InfoGraphic>(
      `${this.url}/${item.id}`,
      item,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new InfoGraphicsService();
